<procure-card
  condensed
  [loading]="isLoading()"
>
  <div class="container">
    <div class="buttons">
      @if (!isFirst()) {
        <button
          class="button previous"
          procure-button
          variant="stroked"
          [disabled]="previousDisabled() || isFirst()"
          (click)="previousPressed.emit()"
        >
          <mat-icon>chevron_left</mat-icon> Previous Step
        </button>
      }
      @if (!isLast()) {
        <button
          class="button next"
          procure-button
          variant="stroked"
          [disabled]="nextDisabled() || isLast()"
          (click)="nextPressed.emit()"
        >
          Next Step <mat-icon>chevron_right</mat-icon>
        </button>
      }
      @if (canFinish()) {
        <button
          class="button next"
          procure-button
          variant="flat"
          [disabled]="finishDisabled()"
          (click)="finishPressed.emit()"
        >
          Finish
        </button>
      }
    </div>
    @if (displayProgress()) {
      <div class="progress">
        <mat-progress-bar
          class="progress-bar"
          mode="determinate"
          [value]="progress()"
        />
      </div>
    }
  </div>
</procure-card>
